import { useQuery } from '@tanstack/react-query';
import { getContratsByClientId } from '../api/CLIENTS/clients';

export const useContratsByClientId = (clientId, { enabled: enabledProp = true } = {}) => {
  return useQuery({
    queryKey: ['contrats', clientId],
    queryFn: () => getContratsByClientId(clientId),
    enabled: !!clientId && enabledProp,
    staleTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  });
};
